<ion-app>
  <!--<ion-menu content-id="main-content" #menu menuId="sideMenu" class="side-menu">
  <ion-header>
    <ion-toolbar>
      <ion-title class="menu-head"><img alt="Simbiq" src="assets/simbiq_logo.png"></ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding menu-btn">
    <ion-menu-toggle>
      <div class="menu-div">
        <ion-button routerLink="/find-care" fill="clear">{{'Find Care' | translateLang | async}}</ion-button>
      </div>
      <div class="menu-div">
        <ion-button routerLink="/my-benefits" fill="clear">{{'My Benefits' | translateLang | async}}</ion-button>
      </div>
      <div class="menu-div">
        <ion-button routerLink="/cost-of-care-calculator" fill="clear">{{'Calculator' | translateLang | async}}</ion-button>
      </div>
      <div class="menu-div">
        <ion-button  routerLink="/my-profile" fill="clear" [queryParams]="{section:'saved-providers'}">{{'Favorites' | translateLang | async}}</ion-button>
      </div>
      <div class="menu-div">
        <ion-button routerLink="/a-to-z-directory" fill="clear">{{'Resources' | translateLang | async}}</ion-button>
      </div>
    </ion-menu-toggle>
  </ion-content>
</ion-menu>-->
<ion-menu content-id="main-content" #caremenu menuId="careGiverMenu" class="side-menu">
  <ion-header>
    <ion-toolbar>
      <ion-title class="menu-head">
        <ion-menu-toggle>
          <img alt="Simbiq" src="assets/simbiq_logo.png" routerLink="/carehub">
        </ion-menu-toggle>
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding menu-btn">
    <ion-menu-toggle auto-hide="true">
      @if (userType!='supportteam') {
        <div class="menu-div">
          <ion-button routerLink="/profile-setup" fill="clear">{{'Profile Setup' | translateLang | async}}</ion-button>
        </div>
      }
      <div class="menu-div">
        <ion-button routerLink="/articles" fill="clear">{{'Articles' | translateLang | async}}</ion-button>
      </div>
      @if (userType!='supportteam') {
        <div class="menu-div">
          <ion-button routerLink="/care-planner" fill="clear">{{'Care Planner' | translateLang | async}}</ion-button>
        </div>
      }
      @if (userType!='supportteam') {
        <div class="menu-div">
          <ion-button routerLink="/calendar-view" fill="clear">{{'Calendar View' | translateLang | async}}</ion-button>
        </div>
      }
      @if (userType!='supportteam') {
        <div class="menu-div">
          <ion-button routerLink="/event-planner" fill="clear">{{'Event Planner' | translateLang | async}}</ion-button>
        </div>
      }
      <div class="menu-div">
        <ion-button routerLink="/task-planner" fill="clear">{{'Task Manager' | translateLang | async}}</ion-button>
      </div>
      <div class="menu-div">
        <ion-button fill="clear" (click)="signOut()">{{'Logout' | translateLang | async}}</ion-button>
      </div>
    </ion-menu-toggle>

    <!--<ion-menu-toggle>
    <ion-button>Close</ion-button>
  </ion-menu-toggle>-->
</ion-content>
</ion-menu>

<ion-router-outlet id="main-content" (activate)="routeChange()" animated="false" (window:resize)="onResize()"></ion-router-outlet>
</ion-app>